// FAQ-style accordion. Two patterns supported:
//   (1) <dl class="accordion"><dt>Q</dt><dd>A</dd>...</dl> — click dt toggles is-open on dt + dd
//   (2) .js-accordion-title + sibling content — click title toggles is-open on both
//
// SCSS handles transition: dd { max-height:0; overflow:hidden; transition:.3s }
// JS sets each open panel's max-height from its actual content height.
export function initAccordion() {
  const openContent = (content) => {
    content.classList.add('is-open');
    content.style.maxHeight = `${content.scrollHeight}px`;
  };

  const closeContent = (content) => {
    content.classList.remove('is-open');
    content.style.maxHeight = '0px';
  };

  const toggleContent = (content) => {
    if (content.classList.contains('is-open')) {
      closeContent(content);
      return;
    }

    openContent(content);
  };

  // Pattern 1: <dl class="accordion">
  document.querySelectorAll('dl.accordion').forEach((dl) => {
    dl.querySelectorAll('dt').forEach((dt) => {
      dt.addEventListener('click', () => {
        const dd = dt.nextElementSibling;
        if (!dd || dd.tagName !== 'DD') return;
        dt.classList.toggle('is-open');
        toggleContent(dd);
      });
    });
  });

  // Pattern 2: .js-accordion-title
  document.querySelectorAll('.js-accordion-title').forEach((title) => {
    title.addEventListener('click', () => {
      title.classList.toggle('is-open');
      const content = title.nextElementSibling;
      if (content) toggleContent(content);
    });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.accordion dd.is-open, .js-accordion-title + .is-open').forEach((content) => {
      content.style.maxHeight = `${content.scrollHeight}px`;
    });
  });
}
